import { t } from 'i18next'
import { FCC } from '~/core/@types/global'
import { TypographyText } from '~/core/ui/Text'
import { cn } from '~/core/ui/utils'
import LPContainer from '../../LPContainer'

const SectionContainer: FCC<{
  className?: string
  tagColor?: string
  tagLabel?: string
  title: string
  titleClassName?: string
  description?: string
  descriptionClassName?: string
}> = ({
  children,
  className,
  tagColor = 'text-purple-500',
  tagLabel,
  title,
  titleClassName,
  description,
  descriptionClassName
}) => {
  return (
    <div
      className={cn('overflow-hidden my-[64px] desktop:my-[140px]', className)}>
      <LPContainer>
        <div className="flex-1 flex flex-col tablet:justify-center max-w-full tablet:max-w-5xl mx-auto tablet:items-center tablet:text-center">
          {tagLabel ? (
            <TypographyText
              className={cn(
                'px-2 w-fit text-base uppercase rounded',
                tagColor
              )}>
              {t(tagLabel)}
            </TypographyText>
          ) : null}

          <h2
            className={cn(
              'scroll-m-20 text-3xl mt-3 mb-4 text-[31px] leading-[36px] tablet:text-[37px] tablet:leading-[42px] font-medium tablet:max-w-[840px] max-w-[343px] text-gray-900 animate-fadeInUp',
              titleClassName
            )}
            dangerouslySetInnerHTML={{
              __html: t(title)
            }}
          />

          {description ? (
            <div
              className={cn(
                'text-[16px] lead-[28px] tablet:max-w-full max-w-[343px]',
                descriptionClassName
              )}
              dangerouslySetInnerHTML={{
                __html: t(description)
              }}
            />
          ) : null}
        </div>

        {children}
      </LPContainer>
    </div>
  )
}

export default SectionContainer
